export default class DemographicsModel {
  constructor(data) {
    if (!data) {
      data = {};
    }
    this.state = data.state || "";
    this.date = data.date || 0;
  }
}